import { MessageCircle } from "lucide-react";

const DEFAULT_NUMBER = "918228025545";
const DEFAULT_MESSAGE = "Hi LibraryOS, I need help with...";

export const buildWhatsAppLink = (phone, message) => {
  const digits = String(phone || "").replace(/\D/g, "");
  const normalized = digits.length === 10 ? `91${digits}` : digits;
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${normalized || DEFAULT_NUMBER}${encoded ? `?text=${encoded}` : ""}`;
};

export default function WhatsAppBubble({ number = DEFAULT_NUMBER, message = DEFAULT_MESSAGE, label = "Chat on WhatsApp" }) {
  return (
    <a
      className="whatsapp-bubble"
      href={buildWhatsAppLink(number, message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
      data-testid="whatsapp-floating-bubble"
    >
      <MessageCircle size={22} />
      <span>{label}</span>
    </a>
  );
}
